import { QUICK_ADD_TO_CART_RESTRICTED_COUNTRIES } from '~~/constants/checkout';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

export default (countryCode: CountryCodeValue): boolean => {

  return QUICK_ADD_TO_CART_RESTRICTED_COUNTRIES.includes(countryCode);

};
